import { useLocation } from 'react-router-dom';

export const useSearchFromParams = () => {
  const { search } = useLocation();
  let query = new URLSearchParams(search);

  return query;
};
